import { DEVICE_ID_KEY } from '@/lib/deviceId'

const PERSISTENT_LOCALSTORAGE_KEYS = ['reinz_promo_last_shown', DEVICE_ID_KEY]

// Clears localStorage on logout while keeping keys that must survive across sessions
// (the gift-promo dismissal date and the device ID used for session/device tracking).
export function clearAppLocalStorage(): void {
  const preserved = PERSISTENT_LOCALSTORAGE_KEYS.map(
    (key) => [key, localStorage.getItem(key)] as const,
  )
  localStorage.clear()
  for (const [key, value] of preserved) {
    if (value) localStorage.setItem(key, value)
  }
}
